module.exports = require('./helpers/bundle-url').getBundleURL('3dwVf') + "logo.c51670a8.svg";